import {cartUnitPrice} from "../../components/common/cart-pricing";

export function createCheckoutPurchase(scope, rows, choices) {
    // Capture the displayed review and exact checkout request so an explicit retry cannot drift.
    const captured = rows.map(row => ({...row}));
    const grouped = new Map();
    captured.forEach(row => {
        if (!grouped.has(row.distributorId)) {
            grouped.set(row.distributorId, {id: row.distributorId, name: row.tenantName, rows: []});
        }
        grouped.get(row.distributorId).rows.push(row);
    });
    return {scope, rows: captured, groups: [...grouped.values()], ids: captured.map(row => row.cartId),
        permissions: Object.fromEntries([...grouped.keys()].map(id => [id, choices[id] === true])),
        prices: Object.fromEntries(captured.map(row => [row.cartId, row.effectiveUnitPrice ?? cartUnitPrice(row)])),
        attempted: false, error: ""};
}
